export const LogoMark = ({ size = 30 }) => (
  <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
    <rect width="64" height="64" rx="14" fill="#0E131F" stroke="rgba(0,229,192,0.35)" />
    <path d="M15 46 L32 14 L49 46" stroke="#00E5C0" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round" />
    <line x1="23" y1="35" x2="41" y2="35" stroke="#F4F6F8" strokeWidth="4" strokeLinecap="round" />
    <circle cx="32" cy="9" r="3.4" fill="#00E5C0" />
  </svg>
);

export default function Logo({ compact = false }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <LogoMark size={compact ? 26 : 30} />
      {!compact && (
        <span className="leading-none">
          <span className="font-display font-semibold text-xl tracking-wide text-bone block">
            ANDROGEN
          </span>
          <span className="mono-label text-teal block mt-0.5" style={{ letterSpacing: "0.34em" }}>
            HEALTH
          </span>
        </span>
      )}
    </span>
  );
}
